import type { Hookable } from 'hookable'
import type { Ref } from 'vue'

import type { BacklogContextEvents } from '../useBacklogContext.events.schema'

interface BacklogWorkspaceSlugChangedLoggerLike {
  debug: (message: string, meta?: Record<string, unknown> | unknown) => void
}

export interface BacklogWorkspaceSlugChangedHandlerParams {
  hooks: Hookable<{
    [K in keyof BacklogContextEvents]: (event: BacklogContextEvents[K]) => void | Promise<void>
  }>
  logger: BacklogWorkspaceSlugChangedLoggerLike
  clearBacklogScopedQueries: () => void
  workitemsQueryKey: Ref<string | undefined>
}

/**
 * Registers a hook handler that clears backlog-scoped queries when the workspace slug changes.
 *
 * This prevents showing stale backlog workitems while upstream team resolution updates.
 */
export default function useBacklogContextOnWorkspaceSlugChanged({
  hooks,
  logger,
  clearBacklogScopedQueries,
  workitemsQueryKey,
}: BacklogWorkspaceSlugChangedHandlerParams) {
  return hooks.hook('WorkspaceSlugChanged', (event) => {
    logger.debug('Backlog workspace slug changed, clearing backlog-scoped queries', event)
    workitemsQueryKey.value = undefined
    clearBacklogScopedQueries()
  })
}
